export const LOGIN_REQUIREMENT_KEY = 'login-requirement';
export default class LocalStorage {
  static get(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  static set(key, value) {
    try {
      return window.localStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
  }
  static getJSON(key) {
    const data = this.get(key);
    if (!data) {
      return null;
    }
    try {
      return JSON.parse(data);
    } catch (error) {
      throw new Error(`Value for key '${key}' is not a JSON`);
    }
  }
  static setJSON(key, value) {
    this.set(key, JSON.stringify(value));
  }
  static getStagedLoginRequirement() {
    return this.getJSON(LOGIN_REQUIREMENT_KEY);
  }
}